import * as React from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'typescript-fsa';
import { ThunkDispatch } from 'redux-thunk';
import { QuestionInterface } from 'Interfaces/Forms/QuestionInterface';
import { FormInterface } from 'Interfaces/Forms/FormsInterface';
import { QueryFiltersInterface } from 'reducers/filtersMenuReducer';
import { fetchPOI, sumValues } from 'actions/pois';
import CalculatedValueQuestion from '../elements/CalculatedValueQuestion';
import { LooseObject } from '../../../Interfaces/LooseObject';
import { DataPoint } from '../../../Interfaces/DataPoint';
import { Locations } from '../../../Interfaces/LocationInterface';
import FormUtils from '../utils/FormUtils';
import { StateInterface } from '../../../Interfaces/StateInterface';
import { ClientPersistInterface } from '../../../Interfaces/ClientPersistInterface';

// import { StateInterface } from '../../Interfaces/StateInterface';

export interface Props {
  updateAnswer: (value: LooseObject) => void;
  question: QuestionInterface;
  formUtils: FormUtils;
  dataPoint: DataPoint;
  forms: FormInterface[];
  parentModel?: LooseObject;
  parentDataPoint?: LooseObject;
  parentQuestion?: LooseObject;
  isSubQuestion?: boolean;
  isTable?: boolean;
  edit?: boolean;
}

export interface StateProps {
  locationHierarchy: Locations;
  pois: LooseObject;
  users: LooseObject;
  clientPersist: ClientPersistInterface;
}

interface ActionProps {
  fetchPOI: (
    formId: string, signal: AbortSignal, fields?: string
  ) => Promise<Response>;
  sumValues: (
    formId: string, signal: AbortSignal, questionId: string, script: string, filters: QueryFiltersInterface[]
  ) => Promise<Response>;
}

export type CalculatedPropsInterface = Props & StateProps & ActionProps;

const CalculatedValueQuestionContainer = (props: CalculatedPropsInterface) => {
  return (
    <CalculatedValueQuestion {...props} />
  );
};

const mapStateToProps = (state: StateInterface): StateProps => {
  return {
    locationHierarchy: state.locations.collection, // read state from parent if there?
    pois: state.answers,
    users: state.users,
    clientPersist: state.clientPersist
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<StateInterface, any, AnyAction>): ActionProps => {
  return {
    fetchPOI: (
      formId: string, signal: AbortSignal, fields?: string
    ): Promise<Response> => {
      return dispatch(fetchPOI(formId, signal, undefined, undefined, undefined, fields));
    },
    sumValues: (
      formId: string, signal: AbortSignal, questionId: string, script: string, filters: QueryFiltersInterface[]
    ) => {
      return dispatch(sumValues(formId, signal, questionId, script, filters));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CalculatedValueQuestionContainer);
